<template>
    <div class="prop-box" :style="propStyle">
      <!-- 道具背景图 -->
      <div class="prop-box-bg">
        <img v-if="prop_type === 0"
            :src="require('@/assets/images/YuliApp/badgeWall/PropItem/bg_reward_item_black.png')">
        <img v-if="prop_type === 1"
            :src="require('@/assets/images/YuliApp/badgeWall/PropItem/bg_reward_item_white.png')">
        <img v-if="prop_type === 2"
            :src="require('@/assets/images/YuliApp/badgeWall/PropItem/bg_reward_item_green.png')">
        <img v-if="prop_type === 3"
            :src="require('@/assets/images/YuliApp/badgeWall/PropItem/bg_reward_item_blue.png')">
        <img v-if="prop_type === 4"
            :src="require('@/assets/images/YuliApp/badgeWall/PropItem/bg_reward_item_purple.png')">
        <img v-if="prop_type === 5"
            :src="require('@/assets/images/YuliApp/badgeWall/PropItem/bg_reward_item_orange.png')">
      </div>
      <!-- 道具图片 -->
      <div class="prop-box-img">
        <img :src="prop_img">
      </div>
      <!-- 数量 -->
      <div class="prop-box-number" v-if="prop_number">
        <div class="prop-box-number-view">
          <img v-if="prop_type === 0"
            :src="require('@/assets/images/YuliApp/badgeWall/PropItem/number/number_bg_black.png')">
          <img v-if="prop_type === 1"
              :src="require('@/assets/images/YuliApp/badgeWall/PropItem/number/number_bg_white.png')">
          <img v-if="prop_type === 2"
              :src="require('@/assets/images/YuliApp/badgeWall/PropItem/number/number_bg_green.png')">
          <img v-if="prop_type === 3"
              :src="require('@/assets/images/YuliApp/badgeWall/PropItem/number/number_bg_blue.png')">
          <img v-if="prop_type === 4"
              :src="require('@/assets/images/YuliApp/badgeWall/PropItem/number/number_bg_purple.png')">
          <img v-if="prop_type === 5"
              :src="require('@/assets/images/YuliApp/badgeWall/PropItem/number/number_bg_orange.png')">
          {{ prop_number }}
        </div>
      </div>
    </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import audioManager from "@/utils/audioManager";
import { anyTypeAnnotation } from "@babel/types";
  
export default {
  components: {},
  props: {
    propStyle: {
      type: Object,
      default: ()=>{
        return {}
      },
    },
    /**道具等级 */
    prop_type: {
      type: Number,
      default: 0
    },
    /**道具图片 */
    prop_img: {
      type: String,
      default: ''
    },
    /**道具数量 */
    prop_number: {
      // type: Number,
      default: 1,
    }
  },

  setup(props, { emit }) {
    // const {  } = props;

    return {
      
    };
  },
};
</script>
  
  <style lang="less" scoped>
    @prop_width: 48px;
    @prop_height: 48px;

    .prop-box{
        width: @prop_width;
        height: @prop_height;
        position: relative;
        // margin-bottom: 9.5px;
        &-bg{
            position: absolute;
            width: @prop_height;
            height: @prop_height;
            z-index: 1;
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-img{
            width: calc(@prop_width * 56 / 64);
            height: calc(@prop_height * 56 / 64);
            z-index: 2;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-number{
            width: 100%;
            height: 15px;
            z-index: 2;
            position: absolute;
            bottom: 2.9px;
            text-align: center;
            font-family: "PingFang SC";
            &-view{
              position: relative;
              width: 100%;
              height: 100%;
              color: rgba(255, 255, 255, 1);
              font-size: 9px;
              padding-top: 2px;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: center;
              img{
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                z-index: -1;
              }
            }
        }
    }
  </style>
  